import React, { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import { filterNulls } from 'dibs-ts-utils/exports/filterNulls';

import styles from './RailTagContainer.scss';

import RailTag from './RailTag';

import { RailTagContainer_tradePhoto } from './__generated__/RailTagContainer_tradePhoto.graphql';

type RailTagContainerProps = {
    tradePhoto: RailTagContainer_tradePhoto;
};

export const RailTagContainer: FC<{
    tradePhoto: RailTagContainer_tradePhoto;
}> = ({ tradePhoto }) => {
    const tags = tradePhoto?.tags || [];
    if (!tags.length) {
        return null;
    }

    const tagRows = tags
        .map((tag, index) => {
            if (!tag || tag === null || !tag.serviceId) {
                return null;
            }
            return <RailTag key={`tag-${index}`} tag={tag} />;
        })
        .filter(filterNulls);

    if (!tagRows.length) {
        return null;
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.headerText}>
                <FormattedMessage
                    id="interiorPhoto.rail.tags.title"
                    defaultMessage="Get The Look"
                />
            </div>
            {tagRows}
        </div>
    );
};

export default createFragmentContainer(RailTagContainer, {
    tradePhoto: graphql`
        fragment RailTagContainer_tradePhoto on TradePhoto {
            tags {
                serviceId
                ...RailTag_tag
            }
        }
    `,
});
